import { stateAbstract, actionsAbstract, mutationsAbstract } from '@/store/abstract'

const state = {
  ...stateAbstract,
  countriesCount: null,
  countriesList: [],
  statesCount: null,
  statesList: [],
  banksCount: null,
  banksList: [],
  documentsCount: null,
  documentsList: [],
  currenciesCount: null,
  currenciesList: [],
  activitiesCount: null,
  activitiesList: [],
  referencesCount: null,
  referencesList: []
}

export default {
  namespaced: true,
  state,
  actions: actionsAbstract,
  mutations: mutationsAbstract
}
